import './styles/app.scss'

import React       from 'react'
import PropTypes   from 'prop-types'
import { connect } from 'react-redux'
import classnames  from 'classnames'

import { Route, Switch, Redirect, withRouter } from 'react-router'

import withAuthentication             from './components/AuthenticatedComponent'
import Navbar                         from './components/Navbar'
import BatchJobsView                  from './components/BatchJobsView'
import ItemList                       from './components/ItemList'
import ItemDetails                    from './components/ItemDetails'
import EndpointDetails                from './endpoint/EndpointDetails'
import UserDetails                    from './users/UserDetails'
import IntegrationDetails             from './integration/IntegrationDetails'
import JobDetails                     from './job/JobDetails'
import DataSourceDetails              from './dataSource/DataSourceDetails'
import DataSystemDetails              from './dataSystem/DataSystemDetails'
import DeliveryConfigDetails          from './deliveryConfig/DeliveryConfigDetails'
import GatewaySchedulerLogDetails     from './logs/GatewaySchedulerLogDetails'
import BatchDeliveryManagerLogDetails from './logs/BatchDeliveryManagerLogDetails'
import MaintenanceTemplateDetails     from './maintenance/MaintenanceTemplateDetails'
import SFTPGatewayDetails             from './sftpGatewayLog/SFTPGatewayDetails'

class App extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
  }

  getIsProduction() {
    const envProduction = process.env.REACT_APP_PRODUCTION

    if (typeof envProduction === 'string' && envProduction.trim() !== '') {
      return envProduction.toLowerCase() === 'true'
    }

    return Boolean(window.config.production)
  }

  getEnvironment() {
    if (this.getIsProduction()) {
      return 'prod'
    }

    console.log(`REACT_APP_ENV: ${process.env.REACT_APP_ENV}`);

    const configEnvironment = (
      process.env.REACT_APP_ENV
      || window.config.environment
      || window.config.env  
      || ''
    ).toString().toLowerCase()
    const hostname = (window.location && window.location.hostname || '').toLowerCase()

    if (configEnvironment.includes('test') || configEnvironment.includes('uat') || hostname.includes('test') || hostname.includes('uat')) {
      return 'test'
    }

    return 'qa'
  }

  componentDidMount() {
    console.log(`Is Production: ${this.getIsProduction()}`);
    console.log(`Environment: ${this.getEnvironment()}`);
    console.log(`PRODUCTION: ${process.env.REACT_APP_PRODUCTION}`);
  }

  render() {
    const { history } = this.props
    const environment = this.getEnvironment()
    const isProduction = this.getIsProduction()
    
    const className = classnames('app-content', {
      production: isProduction,
      'non-production': !isProduction,
      'environment-qa': environment === 'qa',
      'environment-test': environment === 'test',
      'environment-prod': environment === 'prod',
    })

    return (
      <div className="app">
        <div className={className}>
          <Navbar history={history} />
          <BatchJobsView history={history} />

          <div className="item-list-container">
            <Switch>
              <Route exact path="/" render={() => (
                <Redirect to="/jobs"/>
              )}/>

              <Route path="/data-systems/item/:id"                component={DataSystemDetails} />
              <Route path="/delivery-config/:id"                  component={DeliveryConfigDetails} />
              <Route path="/integrations/item/:id"                component={IntegrationDetails} />
              <Route path="/sftp-gateway-logs/item/:logId"        component={SFTPGatewayDetails} />
              <Route path="/data-sources/item/:id"                component={DataSourceDetails} />              
              <Route path="/maintenance-templates/item/:id"       component={MaintenanceTemplateDetails} />
              <Route path="/jobs/item/:id"                        component={JobDetails} />
              <Route path="/users/item/:id"                       component={UserDetails} />
              <Route path="/gateway-scheduler-logs/item/:id"      component={GatewaySchedulerLogDetails} />
              <Route path="/batch-delivery-manager-logs/item/:id" component={BatchDeliveryManagerLogDetails} />
              <Route path="/endpoints/item/:id"                   component={EndpointDetails} />
              <Route path="/:categoryPath/item/:id"               component={ItemDetails} />

              <Route path="/" component={ItemList} />
            </Switch>
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = {}
const mapStateToProps = () => ({})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withAuthentication(withRouter(App)))
